import React, { useState } from "react";
import { IonIcon } from "@ionic/react";
import { Link } from "react-router-dom";
import {
  chevronDownOutline,
  chevronUpOutline,
  downloadOutline,
  mapOutline,
} from "ionicons/icons";
import { igcDownloadLink } from "../common/constants";
import { timeOfDateString } from "../common/TimeUtils";

const identifierOrKey = (record) =>
  record.identifier && record.identifier.trim().length > 0 ? record.identifier : record.key;

const shortTime = (v) => (v ? timeOfDateString(v) : "—");

export default function AprsLogbookRow({ record, rowIndex, setIdentifier, placeOrAnchor }) {
  const [open, setOpen] = useState(false);
  const id = identifierOrKey(record);
  const alt = rowIndex % 2 === 1;

  const stop = (e) => e.stopPropagation();

  return (
    <>
      <tr
        className={`aprs-table__row${alt ? " aprs-table__row--alt" : ""}${open ? " aprs-table__row--open" : ""}`}
        onClick={() => setOpen((v) => !v)}
      >
        <td
          className="aprs-table__id"
          onClick={(e) => {
            stop(e);
            setIdentifier(record.identifier);
          }}
        >
          {id}
        </td>
        <td className="aprs-table__time">{shortTime(record.takeOff)}</td>
        <td className="aprs-table__time">{shortTime(record.landing)}</td>
        <td className="aprs-table__dur">{record.duration || "—"}</td>
        <td className="aprs-table__place" onClick={stop}>
          {placeOrAnchor(record.takeoffPlace) || "—"}
        </td>
        <td className="aprs-table__place" onClick={stop}>
          {placeOrAnchor(record.landingPlace) || "—"}
        </td>
        <td className="aprs-table__expand">
          <IonIcon icon={open ? chevronUpOutline : chevronDownOutline} aria-hidden />
        </td>
      </tr>
      {open && (
        <tr className={`aprs-table__row-detail${alt ? " aprs-table__row-detail--alt" : ""}`}>
          <td colSpan={7}>
            <div className="aprs-table__detail">
              <div className="aprs-table__detail-line">
                <span className="aprs-table__detail-label">OGN / klíč:</span>{" "}
                <span className="aprs-table__detail-key">{record.key}</span>
              </div>
              <div className="aprs-table__detail-line aprs-table__detail-line--actions">
                <span className="aprs-table__detail-hint">Stáhnout / mapa letu</span>
                <span className="aprs-table__actions">
                  {record.hasIgcFile && (
                    <a
                      href={igcDownloadLink(record)}
                      className="aprs-table__action"
                      title="Stáhnout IGC"
                      onClick={stop}
                    >
                      <IonIcon icon={downloadOutline} />
                    </a>
                  )}
                  <Link
                    to={`/aprslogbook/map/${record.id}`}
                    className="aprs-table__action"
                    title="Mapa letu"
                    onClick={stop}
                  >
                    <IonIcon icon={mapOutline} />
                  </Link>
                </span>
              </div>
            </div>
          </td>
        </tr>
      )}
    </>
  );
}
